/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * BonusItemProduct Input Action
 */
export class BonusItemProductInput implements Msdyn365.IActionInput {

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `BonusItemProduct`;
    public getCacheObjectType = () => 'BonusItemProduct';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IBonusItemProductData {
    bonusItemProduct: string;
}

/**
 * Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new BonusItemProductInput();
};

/**
 * Use this function to call your action and process the results as needed
 */
async function action(input: BonusItemProductInput, ctx: Msdyn365.IActionContext): Promise<IBonusItemProductData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IBonusItemProductData[]>('/get/example/id/1', 'get');
    return { bonusItemProduct: '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IBonusItemProductData>>action,
    // Give your data action a unique id
    id: 'BonusItemProduct',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
